// loads Apple MapKit functionality, returns reference to API if successfully loaded
let isLoaded = false;
let mapkitPromise = null;
const mapkitToken = process.env.REACT_APP_MAPKIT_TOKEN;

export function loadMapKit() {
  if (isLoaded) return Promise.resolve(window.mapkit);
  if (!mapkitPromise) {
    mapkitPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js';
        script.async = true;
        script.crossOrigin = 'anonymous';

        script.onload = () => {
            window.mapkit.init({
                authorizationCallback: done => {
                    console.log("TOKEN USED");
                    done(mapkitToken);
                },
            });
            isLoaded = true;
            resolve(window.mapkit);
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
  }
  return mapkitPromise;
}